import { Car, GlassWater, ShieldCheck, ConciergeBell } from "lucide-react";
import { Reveal, Eyebrow } from "./Reveal";

const STANDARDS = [
  {
    icon: Car,
    title: "Better Vehicles",
    body: "Modern, well-maintained vehicles selected for comfort, presence and reliability.",
  },
  {
    icon: GlassWater,
    title: "Thoughtful Comfort",
    body: "Complimentary drinking water and tissues in every vehicle, always.",
  },
  {
    icon: ShieldCheck,
    title: "Built Around Safety",
    body: "Onboard cameras in all vehicles for a safer and more accountable travel experience.",
  },
  {
    icon: ConciergeBell,
    title: "Service That Cares",
    body: "Professional chauffeurs, clean interiors and attention to the small details.",
  },
];

export const BetterStandard = () => (
  <section
    id="standard"
    data-testid="better-standard"
    className="bg-ivory text-dark py-16 sm:py-24 lg:py-[132px]"
  >
    <div className="container-bettr">
      <div className="flex flex-col items-center text-center max-w-3xl mx-auto">
        <Reveal>
          <Eyebrow chapter="01" className="justify-center">
            The Bettr Standard
          </Eyebrow>
        </Reveal>
        <Reveal delay={0.08}>
          <h2 className="font-serif font-normal text-dark mt-6 text-[40px] sm:text-[52px] lg:text-[62px] leading-[1.02] tracking-[-0.02em]">
            We believe travel
            <br className="hidden sm:block" /> should feel better.
          </h2>
        </Reveal>
        <Reveal delay={0.16}>
          <p className="font-sans text-dark/60 text-base sm:text-lg leading-relaxed mt-7 max-w-xl">
            Every Bettr Mobility journey is built on a simple promise —
            your journey will always feel a little better.
          </p>
        </Reveal>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 mt-20 lg:mt-24">
        {STANDARDS.map((s, i) => {
          const Icon = s.icon;
          return (
            <Reveal
              key={s.title}
              delay={i * 0.1}
              data-testid={`standard-feature-${i + 1}`}
              className={`px-8 py-8 lg:py-4 text-center flex flex-col items-center ${
                i !== STANDARDS.length - 1 ? "lg:border-r border-dark/10" : ""
              }`}
            >
              <span className="text-[11px] tracking-[0.3em] text-gold-muted font-semibold mb-6">
                0{i + 1}
              </span>
              <Icon size={34} strokeWidth={1.5} className="text-gold mb-6" />
              <h3 className="font-sans text-dark font-semibold text-[15px] tracking-wide mb-4">
                {s.title}
              </h3>
              <p className="font-sans text-dark/55 text-sm leading-relaxed max-w-[220px]">
                {s.body}
              </p>
            </Reveal>
          );
        })}
      </div>
    </div>
  </section>
);
